import { render } from "./AddToCartComponent.vue?vue&type=template&id=0ced4ef6&scoped=true"
import script from "./AddToCartComponent.vue?vue&type=script&lang=js"
export * from "./AddToCartComponent.vue?vue&type=script&lang=js"

import "./AddToCartComponent.vue?vue&type=style&index=0&id=0ced4ef6&scoped=true&lang=css"

import exportComponent from "C:\\Users\\epentilescu\\source\\repos\\Delicitate V2\\front-end\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ced4ef6"]])

export default __exports__